import getFullTable from '../getFullTable';
export default function getDistinctValuesOfField(records, field) {
    if (typeof records === 'string') {
        records = getFullTable(records);
    }
    const values = records.map(record => record[field]);
    return [...new Set(values)];
}
